export default "__VITE_ASSET__DvTLMfM6__"